import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8081/api',
});

// Interceptador de requisições
api.interceptors.request.use(
    (config) => {
        // Permite rotas públicas sem token
        const publicRoutes = [
            '/auth/login',
            '/auth/register',
            '/auth/forgot-password'
        ];
        if (publicRoutes.some(route => config.url?.includes(route))) {
            return config;
        }

        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            console.error('Token não encontrado. Requisição bloqueada.');
            return Promise.reject(new Error('Token não encontrado. Autenticação é obrigatória.'));
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;